const types = {
    SET_SEARCH_USERS_LIST: '[SEARCH USERS] SET USERS LIST',
}

export {
    types
}